import cn from 'classnames';
import React from 'react';
import ReactPlaceholder from 'react-placeholder';
import { useSelector } from 'react-redux';
import { Store } from 'store';
import getCurrencyId from 'store/price/selector/getCurrencyId';
import getPrice from 'store/price/selector/getPrice';
import getPriceFormat from 'store/price/selector/getPriceFormat';
import formatPrice from 'utils/price/formatPrice';
import styles from './Price.module.scss';

export interface OwnProps {
  categoryId: number;
  productId: number;
  quantity?: number;
  prefix?: string;
  postfix?: string;
  useMinimalQuantity?: boolean;
  usePricePerItem?: boolean;
}

const Price = ({
  categoryId,
  productId,
  quantity,
  prefix,
  postfix,
  useMinimalQuantity,
  usePricePerItem = false,
}: OwnProps) => {
  const currencyId = useSelector(getCurrencyId);
  const priceFormat = useSelector(getPriceFormat);
  const price = useSelector((store: Store) =>
    getPrice(store, categoryId || 0, productId, quantity || 1, false, useMinimalQuantity),
  );

  const isDataReady = Boolean(price && priceFormat && currencyId);
  let initialPrice = 0;
  let currentPrice = 0;
  if (price) {
    initialPrice = usePricePerItem ? price.ipi : price.pi;
    currentPrice = usePricePerItem ? price.ip : price.p;
  }

  return (
    <ReactPlaceholder
      showLoadingAnimation
      type="textRow"
      ready={isDataReady}
      style={{ width: '100px', backgroundColor: '#e8e8e8', margin: 'auto 10px' }}
    >
      {price && priceFormat && currencyId && (
        <span className={styles.price}>
          <span>{prefix}</span>
          <span
            className={cn({
              [styles.crossed]: initialPrice !== currentPrice,
            })}
          >
            {formatPrice(initialPrice, priceFormat, currencyId)}
          </span>
          {initialPrice !== currentPrice ? (
            <span
              className={cn({
                [styles.red]: initialPrice !== currentPrice,
              })}
            >
              {formatPrice(currentPrice, priceFormat, currencyId)}
            </span>
          ) : null}
          {postfix && <span className={styles.postFix} dangerouslySetInnerHTML={{ __html: postfix }} />}
        </span>
      )}
      &nbsp;
    </ReactPlaceholder>
  );
};

export default React.memo(Price);
